import * as Types from '../../../../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type UpdateExamQuestionGroupVersionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  poolId: Types.Scalars['ID'];
}>;


export type UpdateExamQuestionGroupVersionMutation = { __typename?: 'Mutation', updateExamQuestionGroupVersion?: { __typename?: 'UpdateExamQuestionGroupVersionPayload', successful: boolean, examQuestionGroup?: { __typename?: 'ExamQuestionGroup', id: number, isHeadVersion: boolean } | null } | null };

export const UpdateExamQuestionGroupVersionDocument = gql`
    mutation UpdateExamQuestionGroupVersion($id: ID!, $poolId: ID!) {
  updateExamQuestionGroupVersion(id: $id, poolId: $poolId) {
    successful
    examQuestionGroup {
      id
      isHeadVersion
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateExamQuestionGroupVersionGQL extends Apollo.Mutation<UpdateExamQuestionGroupVersionMutation, UpdateExamQuestionGroupVersionMutationVariables> {
    document = UpdateExamQuestionGroupVersionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }